const SystemResultsTable = ({ dataBefore, dataAfter, difference, tableHeaderStyle, tableCellStyle }) => {
    return (
        <>
            <table style={{
                width: '80%', borderCollapse: 'collapse', marginTop: '20px',
                color: '#FFFFFF', border: '2px solid #2196F3', backgroundColor: '#121212'
            }}>
                <thead>
                    <tr style={{ backgroundColor: '#1E1E1E' }}>
                        <th style={tableHeaderStyle}>City-wide Summary</th>
                        <th style={tableHeaderStyle}>Flooding (MG)</th>
                        <th style={tableHeaderStyle}>Infiltration (MG)</th>
                        <th style={tableHeaderStyle}>Outflow (MG)</th>
                        <th style={tableHeaderStyle}>Runoff (MG)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style={tableCellStyle}>Before</td>
                        <td style={tableCellStyle}>{dataBefore?.flooding ? dataBefore.flooding.toFixed(2) : "N/A"}</td>
                        <td style={tableCellStyle}>{dataBefore?.infiltration ? dataBefore.infiltration.toFixed(2) : "N/A"}</td>
                        <td style={tableCellStyle}>{dataBefore?.outflow ? dataBefore.outflow.toFixed(2) : "N/A"}</td>
                        <td style={tableCellStyle}>{dataBefore?.runoff ? dataBefore.runoff.toFixed(2) : "N/A"}</td>
                    </tr>
                    <tr>
                        <td style={tableCellStyle}>After</td>
                        <td style={tableCellStyle}>{dataAfter?.flooding ? dataAfter.flooding.toFixed(2) : "N/A"}</td>
                        <td style={tableCellStyle}>{dataAfter?.infiltration ? dataAfter.infiltration.toFixed(2) : "N/A"}</td>
                        <td style={tableCellStyle}>{dataAfter?.outflow ? dataAfter.outflow.toFixed(2) : "N/A"}</td>
                        <td style={tableCellStyle}>{dataAfter?.runoff ? dataAfter.runoff.toFixed(2) : "N/A"}</td>
                    </tr>
                    {difference && (
                        <tr>
                            <td style={{ ...tableCellStyle, fontWeight: 'bold' }}>Difference</td>
                            <td style={{ ...tableCellStyle, color: difference.flooding >= 0 ? '#00FF00' : '#FF0000' }}>
                                {difference?.flooding ? difference.flooding.toFixed(2) : "N/A"}
                            </td>
                            <td style={{ ...tableCellStyle, color: difference.infiltration >= 0 ? '#00FF00' : '#FF0000' }}>
                                {difference?.infiltration ? difference.infiltration.toFixed(2) : "N/A"}
                            </td>
                            <td style={{ ...tableCellStyle, color: difference.outflow >= 0 ? '#00FF00' : '#FF0000' }}>
                                {difference?.outflow ? difference.outflow.toFixed(2) : "N/A"}
                            </td>
                            <td style={{ ...tableCellStyle, color: difference.runoff >= 0 ? '#00FF00' : '#FF0000' }}>
                                {difference?.runoff ? difference.runoff.toFixed(2) : "N/A"}
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </>
    )
}


export default SystemResultsTable;